module.exports = __webpack_public_path__ + "static/media/transfer-t3.b0802e63.nom";